import React, { Component } from "react";
import PropTypes from "prop-types";

import i18n from "i18n-react";
import onClickOutside from "react-onclickoutside";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  HashLink as Link,
  NavHashLink as NavLink,
} from "react-router-hash-link";

import { DataHandler, StorageHandler } from "C4";
import { storageKeys } from "settings";

class Dropdown extends Component {
  constructor(props) {
    super(props);

    this.state = {
      appId: -1,
      user: "",
      profileImage: "",
    };

    this.handleClickOutside = this.handleClickOutside.bind(this);
  }

  componentDidMount() {
    this.openSettings();
  }

  handleClickOutside() {
    this.props.handleClickOutside();
  }

  async openSettings() {
    const appInfo = await StorageHandler.load(storageKeys.appInfo);
    const { questionHeader } = appInfo;
    this.setState({ profileImage: questionHeader });

    const { appId, user } = this.state;
    if (appId === -1 || user === "") {
      DataHandler.matchAppId().then((id) => {
        StorageHandler.load(storageKeys.user).then((userKey) => {
          const { email } = userKey;
          this.setState({
            appId: id,
            user: email,
            frame: `https://accounts.travpromobile.com/profile/?header=false&email=${email}&app_id=${id}`,
          });
        });
      });
    } else {
      this.setState({
        frame: `https://accounts.travpromobile.com/profile/?header=false&email=${user}&app_id=${appId}`,
      });
    }
  }

  render() {
    const {
      diploma,
      email,
      firstName,
      lastName,
      unreadMessageCount,
      trainingComplete,
    } = this.props;
    const { frame, profileImage } = this.state;
    return (
      <div className="dropDown">
        <div
          className="dropDown__Header"
          style={{
            backgroundImage: `url(${profileImage.replace(
              "front.travpromobile.com",
              "imgtravpromobile.imgix.net"
            )}?quality=70&fm=jpg)`,
          }}
        >
          <Link to="/" className="dropDown__Header-profile">
            <FontAwesomeIcon icon={["fas", "user"]} />
            {`${firstName} ${lastName}`}
            <br />
            <span>{email}</span>
          </Link>
        </div>
        <div className="dropDown__Nav">
          <ul>
            <li>
              <button
                data-trigger="settings"
                data-fancybox-rel="settings"
                className="settings"
                href={frame}
              >
                {i18n.translate("nav.accountSettings")}
              </button>
            </li>
            {/* <li>
              <NavLink
                onClick={this.handleClickOutside}
                activeClassName="is-active"
                to="/main/messages"
              >
                {i18n.translate('nav.messages')}
              </NavLink>
            </li> */}
          </ul>
        </div>
        <div className="dropDown__Footer">
          <hr />
          <ul>
            <li>
              <NavLink
                onClick={this.handleClickOutside}
                activeClassName="is-active"
                to="/logout"
              >
                <FontAwesomeIcon icon={["fas", "sign-out-alt"]} />
                {i18n.translate("general.logOut")}
              </NavLink>
            </li>
          </ul>
        </div>
        <div
          href={frame}
          data-fancybox="settings"
          data-type="iframe"
          className="settings"
        />
      </div>
    );
  }
}

export default onClickOutside(Dropdown);

Dropdown.propTypes = {
  firstName: PropTypes.string,
  lastName: PropTypes.string,
  diploma: PropTypes.func,
  email: PropTypes.string,
  handleClickOutside: PropTypes.func,
  unreadMessageCount: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  trainingComplete: PropTypes.bool,
};

Dropdown.defaultProps = {
  firstName: "Firstname",
  lastName: "Lastname",
  email: "user@email.com",
  diploma: () => {},
  unreadMessageCount: "",
  handleClickOutside: () => {
    this.setState({
      menuToggle: false,
    });
  },
  trainingComplete: false,
};
